export enum InputType {
  TEXT,
  NUMBER,
  SELECT,
  DECIMAL,
}
